import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, MapWidget, MapOverlay, MessageTooltip, Text, MapLayer, MapMenu, MapItem, Image  } from 'components/library'
import { Layer, Popup } from 'components/library/widgets/map/components'

import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import layer01 from './assets/svg_3_2_1_all.svg'
// import layer02 from './assets/svg_3_2_1_18L_36R.svg'
import layer03 from './assets/svg_3_2_1_E24.svg'
import layer04 from './assets/svg_3_2_1_E18.svg'
import layer05 from './assets/svg_3_2_1_rijbaan_r.svg'
import img01 from './assets/Helikopter@2x.jpg'

import './Aspect02.css'

class Aspect02 extends React.Component {

  state = {
    modal: 0,
  }

  render() {
    return (
      <div className="Chapter03-Aspect02">
        <PageContent nospacing>
          <ContentMenu
            menuOnTop
            activeHasBackground
            tabs={[
              'A380',
              'Andere Objecten',
            ]}>

            <ContentMenuTab>
              <MapWidget
                mapImage={mapBaseImage}
                mapBounds={[[0, 0], [3556, 3406]]}
                options={{ minZoom: -1.5 }}>
                  <MapMenu>
                    <MapItem center={[1745,1703]} zoom={-1.5}>

                      <MapOverlay>
                        {this.state.modal === 2 &&
                          <MessageTooltip>
                            <Text><strong>VOP E24</strong></Text>
                            <Text>Wanneer je een A380 naar VOP E24 moet slepen dien je dit via rijbaan A12 of A13 te doen.</Text>
                          </MessageTooltip>
                        }
                        {this.state.modal === 3 &&
                          <MessageTooltip>
                            <Text><strong>VOP E18</strong></Text>
                            <Text>Indien je een A380 naar VOP E18 moet slepen, dien je dit via rijbaan A13 te doen. Dit in verband met de wingspanbeperking op rijbaan A10.</Text>
                          </MessageTooltip>
                        }
                        {this.state.modal === 4 &&
                          <MessageTooltip>
                            <Text><strong>Rijbaan R</strong></Text>
                            <Text>Op rijbaan R geldt een maximum spanwijdte van 69 meter. Sleepbewegingen met een A380 vinden daarom altijd onder begeleiding van een medewerker van de operationele dienst van A.A.S plaats.</Text>
                          </MessageTooltip>
                        }
                      </MapOverlay>

                      <MapLayer>
                        {this.state.modal === 0 &&
                          <Layer url={layer01} bounds={[[0, 0], [3556, 3406]]} />
                        }

                        {this.state.modal === 2 &&
                          <Layer url={layer03} bounds={[[0, 0], [3556, 3406]]} />
                        }
                        <Popup onClick={() => this.setState({ modal: 2 })} position={[2193,1758]} blue textCenter active={this.state.modal === 2}>
                          <Text>VOP E24</Text>
                        </Popup>

                        {this.state.modal === 3 &&
                          <Layer url={layer04} bounds={[[0, 0], [3556, 3406]]} />
                        }
                        <Popup onClick={() => this.setState({ modal: 3 })} position={[2029,1633]} blue textCenter pinOnRight active={this.state.modal === 3}>
                          <Text>VOP E18</Text>
                        </Popup>

                        {this.state.modal === 4 &&
                          <Layer url={layer05} bounds={[[0, 0], [3556, 3406]]} />
                        }
                        <Popup onClick={() => this.setState({ modal: 4 })} position={[1095,1034]} blue textCenter active={this.state.modal === 4}>
                          <Text>Rijbaan R</Text>
                        </Popup>
                      </MapLayer>

                    </MapItem>
                  </MapMenu>
              </MapWidget>
            </ContentMenuTab>

            <ContentMenuTab>
              <div className="has-two-col">
                <div className="col-01">
                  <Text>Het kan voorkomen dat je een ander object dan een vliegtuig moet slepen. Dit kan bijvoorbeeld een helikopter zijn. Als dit het geval is, dan vraagt je afhandelaar vooraf toestemming bij de Flow Manager Aircraft (FMA), dit is een gedelegeerde onder de Havenmeester. Als je afhandelaar toestemming heeft gekregen voer jij de sleep op exact dezelfde wijze uit als een sleepbeweging met een vliegtuig.</Text>
                </div>
                <div className="col-02">
                  <Image src={img01}/>
                </div>
              </div>
            </ContentMenuTab>
          </ContentMenu>
        </PageContent>
      </div>
    )
  }
}

export default Aspect02



// WEBPACK FOOTER //
// ./src/content/chapters/03/02/Aspect02.js